import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SiteSetupComponentService } from '../../site-setup/site-setup.component.service';

@Component({
  selector: 'lib-reject-sign',
  imports: [CommonModule, TranslateModule],
  templateUrl: './reject-sign.component.html',
  styleUrl: './reject-sign.component.scss',
})
export class RejectSignComponent implements OnInit {
  private readonly service = inject(SiteSetupComponentService);
  private readonly activatedRoute = inject(ActivatedRoute);

  public vm = this.service.viewModel;

  public onCloseClick(): void {
    window.close();
  }

  public ngOnInit(): void {
    this.service.rejectExternalContract();
  }
}
